export const CONFIRMATION_PAGE_LOCALE_ROOT =
  "paywall_checkout.confirmation_page";
